import React from "react";
import { faArrowsSpin } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import cn from "classnames";

type Props = {
  size?: SizeProp;
  message?: string | null;
  className?: string;
};

export const Preloader: React.FC<Props> = ({ size, message, className }) => {
  return (
    <div className={cn("flex justify-center items-center h-full", className)}>
      <div className={"flex flex-col"}>
        <FontAwesomeIcon
          icon={faArrowsSpin}
          size={size}
          spin
        />
        {message && (
          <div className="font-bold text-lg mt-3">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};
